// utils/s3.js
export const plutusS3 = {
  putObject: (params) => ({
    promise: async () => {
      const { Key, Body, ContentType } = params;

      const formData = new FormData();
      formData.append("key", Key);
      formData.append("contentType", ContentType || Body.type);
      formData.append("file", Body);

      const res = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/s3/put`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok || data.success !== true) {
        throw new Error("S3 put failed");
      }

      return data;
    },
  }),

  deleteObject: (params) => ({
    promise: async () => {
      const { Key } = params;

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_HOST}/s3/delete-one`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ key: Key }),
        },
      );

      const data = await res.json();

      if (!res.ok || data.success !== true) {
        throw new Error("S3 deleteObject failed");
      }

      return data;
    },
  }),

  // 추가: deleteObjects 메서드
  deleteObjects: (params) => ({
    promise: async () => {
      const { Delete } = params;
      const keys = Delete.Objects.map((obj) => obj.Key);

      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_HOST}/s3/delete`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(keys),
        },
      );

      const data = await res.json();

      if (!res.ok || data.success !== true) {
        throw new Error("S3 deleteObjects failed");
      }

      return data;
    },
  }),

  copyObject: (params) => ({
    promise: async () => {
      const { CopySource, Key } = params;

      const res = await fetch(`${process.env.REACT_APP_BACKEND_HOST}/s3/copy`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sourceKey: CopySource.replace(/^.*?\/(?=image)/, ""),
          destinationKey: Key,
        }),
      });

      const data = await res.json();

      if (!res.ok || data.success !== true) {
        throw new Error("S3 copyObject failed");
      }

      return data;
    },
  }),
};
